import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import CompanySwitchBg from "@/assets/img/eam/company-switching.webp";
import { useCompanyStore } from "@/stores/useCompanyStore"; // 引入全局store
import { message } from "antd";
const CompanySwitcher = () => {
    // 👇 从全局 STORE 取数据（自动同步，不需要props）
    const { companyTree, // 公司列表
    company, // 当前选中公司
    setCompany, // 修改选中公司
    fetchCompanyTree, // 获取公司列表
    loading, } = useCompanyStore();
    // 控制下拉列表展开/收起状态
    const [isExpanded, setIsExpanded] = useState(false);
    // 容器引用
    const containerRef = useRef(null);
    // 初始化：加载公司树
    useEffect(() => {
        if (companyTree.length === 1) {
            fetchCompanyTree();
        }
    }, [fetchCompanyTree, companyTree]);
    // 点击外部关闭下拉
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current &&
                !containerRef.current.contains(event.target)) {
                setIsExpanded(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const handleCompanySelect = (item) => {
        // 1. 判断：和当前选中一样 → 不处理
        if (item.id === company.id) {
            message.info("当前已是该公司，无需切换");
            setIsExpanded(false);
            return;
        }
        setCompany(item);
        setIsExpanded(false);
        // 3. 提示
        message.success(`已切换至：${item.companyName}`);
        // 4. 延迟 300ms 刷新页面（让状态先保存到本地）
        setTimeout(() => {
            window.location.reload(); // 刷新 → 所有接口重新调用
        }, 300);
    };
    const toggleExpand = () => setIsExpanded(!isExpanded);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        .company-switcher-wrapper {
          position: fixed;
          top: 0.5rem;
          right: 0;
          z-index: 100;
          width: auto;
          height: auto;
          pointer-events: none;
        }
        .company-switcher-container {
          position: relative;
          pointer-events: auto;
        }
        .switch-bg-container {
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url(${CompanySwitchBg});
          background-size: contain;
          background-repeat: no-repeat;
          background-position: right center;
          cursor: pointer;
          height: 0.4rem;
          border-radius: 0.04rem;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          padding: 0 0.08rem 0 0.16rem;
          width: auto;
          clip-path: polygon(0 0, calc(100% - 0.1rem) 0, calc(100% - 0.1rem) 100%, 0 100%);
          overflow: visible;
        }
        .company-text {
          color: white;
          font-size: 0.14rem;
          font-weight: 500;
          margin: 0 auto;
        }
        .switch-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.8);
          z-index: 3;
          pointer-events: auto;
        }
        .company-dropdown {
          position: absolute;
          top: calc(100% - 0.34rem);
          right: 0;
          transform: translateX(calc(-5%));
          background-color: #0f3a62;
          opacity: 0.8;
          border-radius: 0.04rem;
          padding: 0.16rem;
          min-width: 2.6rem;
          z-index: 101;
          box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.2);
          border: 0.04rem solid #00FFFF;
          background-origin: border-box;
          background-clip: padding-box, border-box;
        }
        .company-item {
          font-size: 0.22rem;
          padding: 0.08rem 0.16rem;
          color: #ffffff;
          cursor: pointer;
          transition: background-color 0.2s ease;
          white-space: nowrap;
          border-bottom: 0.01rem dashed rgba(255,255,255,0.1);
          text-align: right;
        }
        .company-item:last-child { border-bottom: none; }
        .company-item:hover { background-color: #1e7cff; }
        .company-item.selected { background-color: #1e7cff; font-weight: 500; }
      ` }), _jsx("div", { className: "company-switcher-wrapper", children: _jsxs("div", { ref: containerRef, className: "company-switcher-container", children: [_jsx("div", { className: "switch-bg-container", onClick: toggleExpand, children: _jsx("span", { className: "company-text", children: company?.companyShortName || "公司" }) }), isExpanded && (_jsxs(_Fragment, { children: [_jsx("div", { className: "switch-overlay", onClick: () => setIsExpanded(false) }), _jsx("div", { className: "company-dropdown", children: companyTree.map((item) => (_jsx("div", { className: `company-item ${company.id === item.id ? "selected" : ""}`, onClick: () => handleCompanySelect(item), children: item.companyShortName }, item.id))) })] }))] }) })] }));
};
export default CompanySwitcher;
